var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouterFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8752 16.3333V12.8333H15.1252V16.3333H20.7502C21.3716 16.3333 21.8752 16.8556 21.8752 17.5V24.5C21.8752 25.1443 21.3716 25.6667 20.7502 25.6667H7.25029C6.62897 25.6667 6.12529 25.1443 6.12529 24.5V17.5C6.12529 16.8556 6.62897 16.3333 7.25029 16.3333H12.8752ZM3.32471 10.3097C4.81373 5.67494 9.03072 2.33333 14.0002 2.33333C18.9699 2.33333 23.1869 5.67494 24.6759 10.3097L22.5408 11.0477C21.3495 7.33995 17.976 4.66667 14.0002 4.66667C10.0246 4.66667 6.65105 7.33995 5.45982 11.0477L3.32471 10.3097ZM7.59494 11.7858C8.48836 9.00496 11.0185 7 14.0002 7C16.982 7 19.5122 9.00496 20.4056 11.7858L18.2705 12.5238C17.6749 10.67 15.9881 9.33333 14.0002 9.33333C12.0125 9.33333 10.3257 10.67 9.73006 12.5238L7.59494 11.7858Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouterFill);
export default __webpack_public_path__ + "static/media/router-fill.f0df1274058293a8b450dda7dc63f973.svg";
export { ForwardRef as ReactComponent };